import { createSlice } from "@reduxjs/toolkit";
import { LoyaltyCustomerInfo } from "../../../utils/loyaltyTypes";
import { fetchLoyaltyCustomerInfo } from "../http/getLoyaltyCustomerInfoThunk";

type LoyaltyCustomerInfoState = {
  data: LoyaltyCustomerInfo | null;
  status: "idle" | "loading" | "succeeded" | "failed";
};

const initialState: LoyaltyCustomerInfoState = {
  data: null,
  status: "idle",
};

const loyaltyCustomerInfoSlice = createSlice({
  name: "loyaltyCustomerInfo",
  initialState,
  reducers: {
    clearLoyaltyCustomerInfo: (state) => {
      state.data = null;
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoyaltyCustomerInfo.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLoyaltyCustomerInfo.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        state.data = payload;
      })
      .addCase(fetchLoyaltyCustomerInfo.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { clearLoyaltyCustomerInfo } = loyaltyCustomerInfoSlice.actions;

export default loyaltyCustomerInfoSlice.reducer;
